import { useSettings } from "@/context/SettingsContext";
import Layout from "@/components/Layout";
import Seo from "@/components/Seo";

const PAGES = {
  terms: { key: "terms_content", title: "Общи условия" },
  privacy: { key: "privacy_content", title: "Политика за поверителност" },
};

export default function StaticPage({ kind }) {
  const settings = useSettings();
  const cfg = PAGES[kind] || PAGES.terms;
  const content = (settings[cfg.key] || "").trim();
  const paragraphs = content.split("\n").filter((p) => p.trim());

  return (
    <Layout showTicker={false}>
      <Seo title={cfg.title} description={`${cfg.title} на „Подуяне Днес“.`} />
      <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8" data-testid={`static-page-${kind}`}>
        <h1 className="font-display text-3xl font-extrabold text-slate-900 sm:text-4xl">{cfg.title}</h1>
        <div className="mt-6 space-y-4 text-[16px] leading-relaxed text-slate-700">
          {paragraphs.length > 0 ? (
            paragraphs.map((p, i) => <p key={i}>{p}</p>)
          ) : (
            <p className="text-slate-400">Съдържанието все още не е добавено.</p>
          )}
        </div>
      </div>
    </Layout>
  );
}
